export const ROUTES = Object.freeze({
  INDEX: `/`,
  SELECT_PORTAL: `/portal`,
  DASHBOARD: `/dashboard`,
  WELCOME:`/welcome-page`,
  COMPLETION: `/login/completion`,
  REGISTER_COMPLETION: `/register/completion`,
  COMPLETION_DATA: `/login/completion-data`,
  LOGIN_SUCCESS: `/login/success`,
  LOGIN_INVITATION_FAILED: `login/invitation/failed`,
  LOGIN_INVITATION_SUCCESS: `login/invitation/success`,
  LOGIN_INVITATION: `/login/invitation`,
  INVOICE: `/order/invoice`,
  USER: {
    LIST: `/admin/user-management/user`,
    DETAIL: `/admin/user-management/user/detail`,
    UPDATE: `/admin/user-management/user/edit`
  },
  INVITATION: {
    LIST: `/admin/user-management/user/invitation`,
    ADD: `/admin/user-management/user/invitation/add`
  },
  PARAMETER: {
    LIST: `/setup/profile-configuration/system-parameters`,
    DETAIL: `/setup/profile-configuration/system-parameters/detail`,
    ADD: `/setup/profile-configuration/system-parameters/add`,
    EDIT: `/setup/profile-configuration/system-parameters/edit`,
  },
  ADDITIONAL_PROOFS: {
    LIST: `/setup/profile-configuration/additional-proofs`,
    DETAIL: `/setup/profile-configuration/additional-proofs/detail`,
    ADD: `/setup/profile-configuration/additional-proofs/add`,
    EDIT: `/setup/profile-configuration/additional-proofs/edit`,
  },
  ROLE: {
    LIST: `/role`,
    DETAIL: `/role/detail`,
    ADD: `/role/add`,
    EDIT: `/role/edit`,
  },
  DEPOT_CONFIG: {
    LIST: `/setup/depot-configuration`,
    DETAIL: `/setup/depot-configuration/detail`,
    ADD: `/setup/depot-configuration/add`,
    EDIT: `/setup/depot-configuration/edit`,
    MAPS: `/setup/depot-configuration/maps`
  },
  CUSTOMER: {
    LIST: `/master/customer`,
    DETAIL: `/master/customer/detail`,
    ADD: `/master/customer/add`,
    EDIT: `/master/customer/edit`,
    MAPS: `/master/customer/maps`
  },
  SELLER: {
    LIST: `/master/seller`,
    DETAIL: `/master/seller/detail`
  },
  DRIVER: {
    LIST: `/driver`,
    DETAIL: `/driver/detail`,
    ADD: `/driver/add`,
    EDIT: `/driver/edit`,
  },
  ALL_TRIP: {
    LIST: `/alltrip`,
    DETAIL: `/alltrip/detail`,
    ADD: `/alltrip/add`,
    EDIT: `/alltrip/edit`,
  },
  ORDER_REQUEST: {
    LIST: `/order-request`,
    DETAIL: `/order-request/detail`,
    ADD: `/order-request/add`,
    EDIT: `/order-request/edit`,
  },
  ADDRESS_FORMAT_CONFIG: {
    LIST: `/setup/profile-configuration/address-format-configuration`,
    EDIT: `/setup/profile-configuration/address-format-configuration/edit`
  },
  SKILLSET: {
    LIST: `/master/fleet/skillset`,
    DETAIL: `/master/fleet/skillset/detail`,
    ADD: `/master/fleet/skillset/add`,
    EDIT: `/master/fleet/skillset/edit`
  },
  VEHICLE: {
    LIST: `/master/fleet/vehicle`,
    ADD: `/master/fleet/vehicle/add`,
    DETAIL: `/master/fleet/vehicle/detail`,
    EDIT: `/master/fleet/vehicle/edit`
  },
  COMPANY_PROFILE: {
    DETAIL: `/setup/profile-configuration/company-profile`,
    EDIT: `/setup/profile-configuration/company-profile/edit`,
  },
  DELIVERY_TYPE: {
    LIST: `/master/fleet/delivery-type`,
    ADD: `/master/fleet/delivery-type/add`,
    EDIT: `/master/fleet/delivery-type/edit`,
    DETAIL: `/master/fleet/delivery-type/detail`,
  },
  DELIVERY_ASSOCIATE: {
    LIST: `/master/fleet/delivery-associate`,
    ADD: `/master/fleet/delivery-associate/add`,
    EDIT: `/master/fleet/delivery-associate/edit`,
    DETAIL: `/master/fleet/delivery-associate/detail`,
  },
  PALLET: {
    LIST: `/master/fleet/pallet`,
    ADD: `/master/fleet/pallet/add`,
    EDIT: `/master/fleet/pallet/edit`,
    DETAIL: `/master/fleet/pallet/detail`,
  },
  TRIP_PLANNING: {
    LIST: `/routes/trip-planning`,
    DETAIL: `/routes/trip-planning/detail`,
    DETAIL2: `/routes/trip-planning/detail/intrip`,
    ADD: `/routes/trip-planning/add`,
  },
  UOM: {
    LIST: `/setup/profile-configuration/unit-of-measurement`,
    ADD: `/setup/profile-configuration/unit-of-measurement/add`,
    EDIT: `/setup/profile-configuration/unit-of-measurement/edit`,
    DETAIL: `/setup/profile-configuration/unit-of-measurement/detail`
  },
  DATA_GROUP: {
    LIST: `/admin/user-management/data-group`,
    ADD: `/admin/user-management/data-group/add`,
    DETAIL: `/admin/user-management/data-group/detail`,
    EDIT: `/admin/user-management/data-group/edit`
  },
  TEMPERATURE_CATEGORY: {
    LIST: `/setup/profile-configuration/temperature-category`,
    ADD: `/setup/profile-configuration/temperature-category/add`,
    DETAIL: `/setup/profile-configuration/temperature-category/detail`,
    EDIT: `/setup/profile-configuration/temperature-category/edit`
  },
  ERROR: {
    BAD_REQUEST: `/error/bad-request`,
    UNAUTHORIZE: `/error/unauthorize`,
    FORBIDDEN: `/error/forbidden`,
    NOT_FOUND: `/error/not-found`,
    INTERNAL_SERVER_ERROR: `/error/internal-server-error`
  },
  GROMART_ORDER: {
    LIST: `/gromart-order`,
    DETAIL: `/gromart-order/detail`,
  },
  DELIVERY_PAYMENT: {
    LIST: `/delivery-payment`,
    DETAIL: `/delivery-payment/detail`,
  },
  BILLING_INVOICE: {
    FILTER: `/billing-invoice`,
    REPORT: `/billing-invoice/report`,
  },
  ORDER_GROUP_PAYMENT: {
    LIST: `/order-group-payment`,
    DETAIL: `/order-group-payment/detail`,
  },
  SHIPPING_COST_PAYMENT: {
    LIST: `/shipping-cost-payment`,
    DETAIL: `/shipping-cost-payment/detail`,
  },
  LOG_REPORT:{
    LIST: `/log-report`
  },
  REPORT_DEPOT: {
    LIST: `/report/report-depot`
  },
  REPORT_ORDER : {
    LIST : `/report/report-order`
  },
  REPORT_DELIVERY_ASSOCIATE: {
    LIST: `/report/report-delivery-associate`
  },
  REPORT_TRIP : {
    LIST: `/report-trip`
  }, 
});